(function () {
    'use strict';

    angular
        .module('core.directives')
        .directive('emailField', EmailField);

    /** @ngInject */
    function EmailField($rootScope, LoadingHelper, UtilHelper, EmailTypeService, PATHS) {
        function EmailFieldController() {
            const vm = this;

            vm.addEmail = () => {
                vm.ammountOfEmails++;
            }

            vm.removeEmail = index => {
                vm.emails.splice(index, 1);

                vm.ammountOfEmails--;
            }

            vm.getNumber = num => {
                return new Array(num);
            }

            vm.getEmailTypes = () => {
                LoadingHelper.startLoading('.email-container', true);

                return EmailTypeService
                    .getAll()
                    .then(success => {
                        vm.emailTypes = success;
                        LoadingHelper.stopLoading('.email-container')
                    }, error => {
                        UtilHelper.errorCallback(error);
                        LoadingHelper.stopLoading('.email-container')
                    })
            }

            init();

            function init() {
                vm.emailTypes = [];
                vm.getValidationMessage = $rootScope.ValidationMessage;
            }
        }

        function link(scope, element, attrs, ctrl) {
            ctrl.getEmailTypes()
                .then(() => {
                    ctrl.ammountOfEmails = 1;

                    if (ctrl.emails && ctrl.emails.length) {
                        ctrl.ammountOfEmails = ctrl.emails.length;
                    } else {
                        ctrl.emails = [];
                    }

                    if (ctrl.ammountOfEmails == 0)
                        ctrl.ammountOfEmails = 1;
                })
        }

        return {
            bindToController: true,
            controller: EmailFieldController,
            controllerAs: 'vm',
            link: link,
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/email-field/email-field.html`,
            scope: {
                emails: '=',
                canEdit: '=',
                showType: '='
            }
        }
    }
}());